import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ZapIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    const target = document.getElementById('pricing');
    if (!target) return;
    const start = window.scrollY;
    const end = target.getBoundingClientRect().top + start - 80;
    const duration = 2000;
    const startTime = performance.now();
    const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const step = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, start + (end - start) * easeInOutCubic(progress));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  return <section className="relative flex items-center justify-center overflow-hidden bg-transparent pt-[0px] pb-[0px]" data-id="element-196">
      {/* Neon Background Effects */}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-197">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[600px] bg-[#ec4899]/5 rounded-full blur-[120px] opacity-30" data-id="element-198" />
        <div className="absolute bottom-0 right-0 w-[800px] h-[800px] bg-[#00f0ff]/5 rounded-full blur-[150px] opacity-20" data-id="element-199" />
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:40px_40px] [mask-image:radial-gradient(ellipse_at_center,black_30%,transparent_90%)] opacity-10" data-id="element-200" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 text-center flex flex-col items-center" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="w-full" data-id="element-202">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#1a0b2e] border border-[#ec4899]/30 text-[#ec4899] text-sm font-bold mb-4 shadow-[0_0_15px_rgba(236,72,153,0.2)]" data-id="element-203">
            <ZapIcon className="w-4 h-4 fill-[#ec4899]" data-id="element-204" />
            CURSO PROFESIONAL DE NEON FLEX
          </div>

          <h1 className="text-5xl md:text-7xl lg:text-[5.5rem] font-black text-white leading-[1] tracking-tight mb-4" data-id="element-205">
            DOMINÁ EL ARTE DEL <br data-id="element-206" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00f0ff] via-[#ec4899] to-[#8b5cf6] drop-shadow-[0_0_30px_rgba(236,72,153,0.3)]" data-id="element-207">
              NEON FLEX
            </span>
          </h1>

          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="relative w-full max-w-[60rem] mx-auto aspect-square md:aspect-[1/1]" data-id="element-208">
            <motion.img src="https://cdn.magicpatterns.com/uploads/i2jjgfv1HZHf9vVVDUCU1h/neon_flex_pri.webp" alt="Pack Maestría Neon Flex" width={1000} height={1000} fetchPriority="high" loading="eager" decoding="async" style={{
            mixBlendMode: 'screen'
          }} className="w-full h-auto relative z-10" data-id="element-209" />

            {/* Neon Glow Behind */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#00f0ff]/20 via-[#ec4899]/10 to-[#8b5cf6]/20 blur-[100px] -z-10 rounded-full opacity-50" data-id="element-210" />
          </motion.div>

          <p className="text-xl md:text-2xl text-gray-300 mb-6 max-w-3xl mx-auto font-medium leading-relaxed" data-id="element-211">
            Convertí tu creatividad en un negocio rentable creando carteles
            luminosos profesionales. Aprendé desde cero con el método más
            completo del mercado.
          </p>

          <div className="flex flex-col items-center gap-6" data-id="element-212">
            <motion.button whileHover={{
            scale: 1.05,
            boxShadow: '0 0 30px rgba(236, 72, 153, 0.4)'
          }} whileTap={{
            scale: 0.98
          }} onClick={scrollToPricing} className="bg-gradient-to-r from-[#ec4899] to-[#8b5cf6] text-white font-black text-xl md:text-2xl px-14 py-6 rounded-2xl uppercase tracking-wider transition-all border border-white/20 w-full md:w-auto shadow-[0_10px_40px_rgba(236,72,153,0.3)]" data-id="element-213">
              QUIERO APRENDER NEON FLEX
            </motion.button>

            {/* Social Proof */}
            <div className="flex flex-col items-center gap-3" data-id="element-214">
              <div className="flex gap-1.5" data-id="element-215">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400 drop-shadow-[0_0_8px_rgba(250,204,21,0.5)]" data-id="element-216" />)}
              </div>
              <p className="text-base font-bold text-gray-400 tracking-wide" data-id="element-217">
                +1,500 ALUMNOS YA ESTÁN CREANDO SUS CARTELES
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}